import { jsx } from 'react/jsx-runtime';

const Margin = (props) => jsx("div", { style: { margin: props.margin }, "data-zds": true, children: props.children });

export { Margin };
//# sourceMappingURL=Margin.es.js.map
